
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.183 16.03a5.188 5.188 0 100-10.375 5.188 5.188 0 000 10.375z","stroke":"#fff","stroke-width":"2","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M14.907 5.848a5.189 5.189 0 111.408 10.182","stroke":"#EDC843","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M1 19.76a8.781 8.781 0 0114.367 0","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.316 16.03a8.77 8.77 0 017.184 3.73","stroke":"#EDC843","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    